<template>
  <content class="integral-content">
    <el-row>
      <el-col :span="8" v-for="(item, index) in top_nav" :key="item.id">
        <div class="integral-com">
          <span>{{ item.name }}</span>
          <span>{{ item.num }}</span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" class="add-oil">
        <el-button
          type="primary"
          plain
          @click="dialogVisible = true"
          size="small"
        >
          添加联盟油站
        </el-button>
        <el-select
          @change="changeLabel"
          class="xz-options"
          size="small"
          v-model="value"
          placeholder="筛选联盟"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        style="width: 100%;margin-top:20px"
      >
        <el-table-column
          prop="alliance_room"
          label="联盟商家"
        ></el-table-column>
        <!-- <el-table-column
          prop="alliance_room"
          label="本站使用联积分"
        ></el-table-column> -->
        <el-table-column prop="point" label="使用积分"></el-table-column>
        <el-table-column prop="used_point" label="消耗积分"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">{{
            scope.row.status | now_status
          }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status === 0 || scope.row.status === 1"
              @click="close_liance(scope.row.alliance_app_id)"
              style="color:#e27470"
              >解除联盟</el-button
            >
            <!-- <el-button
              v-else
              style="color:#e27470"
              type="text"
              @click="open_liance(scope.row.alliance_app_id)"
              >开启联盟</el-button
            > -->
            <el-button
              type="text"
              @click="
                $router.push(
                  `point-order?alliance_app_id=${scope.row.alliance_app_id}`
                )
              "
            >
              记录详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="bot-pagination"
        background
        layout="prev, pager, next"
        :page-count="total"
      ></el-pagination>
    </el-row>
    <!-- 添加聯盟油站 -->
    <el-dialog
      title="请查询并选择要添加的油站"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div>
        <el-input
          placeholder="请输入内容"
          v-model="name"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getAppMsg"
          ></el-button>
        </el-input>
        <el-radio-group
          size="small"
          style="margin-top: 20px"
          v-model="alliance_app_id"
        >
          <el-radio-button
            v-for="(item, index) in shopOption"
            :label="item.app_id"
            :key="index"
          >
            {{ item.name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addShop">确 定</el-button>
      </span>
    </el-dialog>
  </content>
</template>
<script>
import { Button, Slider } from "element-ui";
import {
  getIntegralList,
  cancelAlliance,
  addAlliance,
  getAppMsg,
  getLianceList
} from "@/api/merchant";
import { mapGetters } from "vuex";
export default {
  components: {
    Button,
    Slider
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  filters: {
    now_status: function(val) {
      switch (val) {
        case 0:
          return "邀请中";
        case 1:
          return "联盟成立";
        case 2:
          return "联盟拒绝";
        case 3:
          return "联盟结束";
        // case -1:
        //   return "待审核邀请";
        default:
          break;
      }
    }
  },
  data() {
    return {
      visible: false,
      // 0邀请中 1联盟成立 2联盟拒绝 3联盟结束
      top_nav: [
        {
          id: 0,
          name: "油站",
          num: ""
        },
        {
          id: 1,
          name: "本站消耗他站积分",
          num: ""
        },
        {
          id: 2,
          name: "他站消耗本站积分",
          num: ""
        }
      ],
      dialogVisible: false,
      tableData: [],
      total: 0,
      loading: true,
      value: 1,
      oil_str: "",
      selectArr: [],
      sideItem: [
        {
          id: 1,
          name: "联盟列表",
          url: "market/marketing/client/integral/integral-list"
        },
        {
          id: 2,
          name: "积分订单",
          url: "market/marketing/client/integral/point-order"
        }
      ],
      options: [
        {
          value: 0,
          label: "邀请中"
        },
        {
          value: 1,
          label: "联盟成立"
        },
        {
          value: 2,
          label: "联盟拒绝"
        },
        {
          value: 3,
          label: "联盟结束"
        }
        // {
        //   value: -1,
        //   label: "待审核邀请"
        // }
      ],
      shopOption: [],
      alliance_app_id: "",
      name: "" //搜索
    };
  },
  created() {
    this.getPointList();
  },
  methods: {
    async addShop() {
      try {
        if (this.alliance_app_id == "") {
          this.$message.warning("请先选择一个油站！！！");
          return;
        }
        const data = {
          token: this.token,
          app_id: this.app_id,
          alliance_app_id: this.alliance_app_id
        };
        const res = await addAlliance(data);
        this.$message.success(res.msg);
        this.getPointList();
        this.name = "";
        this.alliance_app_id = "";
        this.shopOption = [];
        this.dialogVisible = false;
      } catch (error) {
        this.name = "";
        this.shopOption = [];
        this.alliance_app_id = "";
        console.log(error);
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          // done();
          this.name = "";
          this.alliance_app_id = "";
          this.shopOption = [];
          this.dialogVisible = false;
        })
        .catch(_ => {});
    },
    changeLabel(arr) {
      this.getPointList(arr.toString());
    },
    async open_liance(app_id) {
      try {
        const data = {
          token: this.token,
          app_id: this.app_id,
          alliance_app_id: app_id
        };
        const res = await addAlliance(data);
        this.$message.success(res.msg);
        this.getPointList();
      } catch (error) {
        console.log(error);
      }
    },
    //添加联盟时获取应用的id名称
    async getAppMsg() {
      try {
        const data = {
          token: this.token,
          app_id: this.app_id,
          name: this.name
        };
        const res = await getAppMsg(data);
        this.shopOption = res.data;
        this.$message.success(res.msg);
        console.log(res);
        // this.getPointList();
      } catch (error) {
        console.log(error);
      }
    },
    // 解除关系
    async close_liance(app_id) {
      this.$confirm("确认解除联盟关系吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const data = {
          token: this.token,
          app_id: this.app_id,
          alliance_app_id: app_id
        };
        cancelAlliance(data).then(res => {
          this.$message(res.msg);
          this.getPointList();
        });
      });
    },
    async getPointList(status = "1") {
      try {
        this.loading = true;
        const data = { token: this.token, app_id: this.app_id, status };
        const res = await getIntegralList(data);
        if (res.code === 200) {
          if (res.data.data.length > 0) {
            const { num, use_total, be_used_total } = res.data;
            // console.log("数据", num, use_total, be_used_total);
            this.top_nav.forEach((item, index) => {
              switch (index) {
                case 0:
                  item.num = num;
                  break;
                case 1:
                  item.num = use_total;
                  break;
                case 2:
                  item.num = be_used_total;
                  break;
              }
            });
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.tableData = [];
            this.$message.error("暂无数据...");
            this.loading = false;
          }
        } else {
          throw res;
        }
      } catch (error) {
        this.tableData = [];
        this.$message.error(res.msg);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.integral-content {
  padding: 0 10px;
}
.integral-com {
  width: 100%;
  height: 80px;
  display: flex;
  font-size: 18px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 20px;
  border-right: 1px solid #fff;
  background-color: #fafafa;
}
.integral-com:nth-child(3) {
  border-right: none;
}
.add-oil {
  width: 100%;
  margin: 20px 0;
}
.bot-pagination {
  float: right;
  margin-top: 20px;
}
.xz-options {
  width: 300px;
  margin-left: 20px;
}
</style>
